<template>
  <section class="BlogIndex">
    <app-menu :active.sync="menuOpened" :bottom="true" />
    <top-navbar :menu-opened.sync="menuOpened" />
    <blog-banner :items="banner_items" />
    <div class="blog-index-content">
      <div class="blog-content">
        <header>
          <!-- <h3 class="title-with-icon" v-if="currentCategory === null">
                        <img src="@/assets/img/svg/articles.svg" alt="">
                        <span>Recentes</span>
                    </h3> -->
          <ul class="blog-content-tabs">
            <li v-for="item in tabs" :key="item.name">
              <a
                :class="{
                  active:
                    item === currentCategory ||
                    (currentCategory == 'null' && item.title == 'RECENTES'),
                }"
                :to="{ name: item.name }"
                @click="selectCategory(item)"
              >
                <component :is="item.icon" class="icon"></component>
                {{ item.title }}
              </a>
            </li>
          </ul>
        </header>
        <section>
          <div class="post-list post-list-mobile-grid-v">
            <div class="post-list-item" v-for="post in posts" :key="post.id">
              <post-card
                :type="post.category"
                :is-square-cover="
                  currentCategory && currentCategory.type == 'podcast'
                "
                :post="post"
              />
            </div>
          </div>
        </section>
        <a class="button button-blue show-more" v-on:click="paginate()">
          Carregar Mais
        </a>
      </div>
      <aside class="blog-sidebar">
        <!-- <logo-card theme="orange">
          <strong>Agende atendimento</strong> com um advogado.
        </logo-card>
        <hr /> -->
        <post-links
          v-if="links_more_readed.length > 0"
          icon="most_read"
          title="MAIS LIDOS"
          :links="links_more_readed"
        >
          <hr />
        </post-links>
        <post-links
          icon="events"
          title="EVENTOS"
          :links="links_events"
          v-if="links_events.length > 0"
        >
          <hr />
        </post-links>

        <post-links
          icon="news"
          title="NOTÍCIAS"
          :links="links_news"
          v-if="links_news.length > 0"
          ><hr />
        </post-links>

        <post-links
          icon="podcast"
          title="PODCAST"
          :links="links_podcasts"
          v-if="links_podcasts.length > 0"
          ><hr />
        </post-links>
        <logo-card theme="blue">
          Está com alguma <strong>dúvida jurídica</strong>?
        </logo-card>
      </aside>
    </div>
    <newsletter theme="orange" />
  </section>
</template>

<script>
import ArticleIcon from "@/components/Svg/ArticleIcon";
import BlogBanner from "@/components/Blog/Banner";
import EventIcon from "@/components/Svg/EventIcon";
import Menu from "@/components/Menu.vue";
import Newsletter from "@/components/Newsletter";
import PodcastIcon from "@/components/Svg/PodcastIcon";
import PostCard from "@/components/Blog/PostCard";
import PostLinks from "@/components/Blog/PostLinks";
import TopNavbar from "@/components/Blog/TopNavbar";
import VideoIcon from "@/components/Svg/VideoIcon";
import LogoCard from "@/components/LogoCard";
import api from "../../services/api";

export default {
  components: {
    "app-menu": Menu,
    ArticleIcon,
    BlogBanner,
    EventIcon,
    LogoCard,
    Newsletter,
    PodcastIcon,
    PostCard,
    PostLinks,
    TopNavbar,
    VideoIcon,
  },

  data() {
    return {
      links_events: [],
      links_news: [],
      links_podcasts: [],
      links_more_readed: [],
      posts: [],

      loading: false,

      banner_items: [],
      tabs: [
        {
          id: null,
          title: "RECENTES",
          icon: "article-icon",
          type: "post",
          category: "null",
        },
        {
          id: 0,
          title: "ARTIGOS",
          icon: "article-icon",
          type: "post",
          category: "artigos",
        },
        {
          id: 1,
          title: "VÍDEOS",
          icon: "video-icon",
          type: "video",
          category: "videos",
        },
        {
          id: 5,
          title: "PODCAST",
          icon: "podcast-icon",
          type: "podcast",
          category: "podcast",
        },
        {
          id: 6,
          title: "EVENTOS",
          icon: "event-icon",
          type: "event",
          category: "eventos",
        },
      ],

      menuOpened: false,
      currentCategory: {
        id: null,
        title: "RECENTES",
        icon: "article-icon",
        type: "post",
        category: "null",
      },
    };
  },

  async created() {
    // this.posts = posts;
    // this.posts_filtered = posts;

    // if (this.$route.params.category) {
    //   console.log("aa");
    // } else {
    //   console.log("bbb");
    // }

    // await this.getPosts();
    await this.getBanners();
    await this.getHighlights();
  },

  // computed: {
  //   tabs() {
  //     return ;
  //   },
  // },

  methods: {
    async selectCategory(category) {
      console.log("categoria", category);
      this.currentCategory = category;
      // Carregar os artigos aqui

      await this.getPosts(category.id, 0);
    },

    async getBanners() {
      const { data: banners } = await api.get("posts/banners");
      console.log("banners", banners);
      this.banner_items = banners;
    },

    async getHighlights() {
      const { data: highlights } = await api.get("posts/highlights");
      console.log("highlights", highlights);
      this.links_more_readed = highlights.most_read;
      this.links_podcast = highlights.podcasts;
      this.links_events = highlights.events;
    },

    async getPosts(category, offSet) {
      this.loading = true;

      try {
        const { data: data_posts } = await api.get(
          "posts?category=" + category + "&offSet=" + offSet
        );
        console.log(data_posts);
        this.posts = data_posts;
      } finally {
        this.loading = false;
      }
    },

    async paginate() {
      this.loading = true;

      try {
        const { data } = await api.get(
          "posts?category=" + this.currentCategory.id + "&offSet=" + this.posts?.length
        );
        console.log('data', data)
        if (data.length == 0) this.posts.splice(0);
        else this.posts = this.posts.concat(data);
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    $route: {
      immediate: true,
      async handler() {
        var category = this.tabs.filter((tab) => {
          return tab.category == this.$route.params.category;
        })[0];
        console.log("categoria", category);
        await this.selectCategory(category ?? "null");
      },
    },
  },
};
</script>

<style>
</style>
